import {appStoreBadge, googlePlayBadge} from '@gaia/images/badges';
import theme from '@gaia/theme';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';

export interface AppButtonsProps extends React.HTMLProps<HTMLDivElement> {
    analyticsContext: string;
}

export default function AppButtons({analyticsContext, ...props}: AppButtonsProps) {
    return (
        <div {...props}>
            <a
                href={'https://itunes.apple.com/us/app/gaia-gps/id1201979492?mt=8&uo=4'}
                target='itunes_store'
                onClick={() =>
                    ampli.selectDownloadIOsApp({
                        category: 'map2',
                        label: analyticsContext,
                    })
                }
            >
                <img
                    width='135'
                    src={appStoreBadge}
                    alt='Download on the App Store'
                    style={{marginRight: theme.spacing(1)}}
                    className='hide-if-android'
                />
            </a>
            <a
                href='https://market.android.com/details?id=com.trailbehind.android.gaiagps.pro&hl=en'
                target='_blank'
                rel='noopener noreferrer'
                onClick={() =>
                    ampli.selectDownloadAndroidApp({
                        category: 'map2',
                        label: analyticsContext,
                    })
                }
            >
                <img
                    width='135'
                    src={googlePlayBadge}
                    alt='Get it on Google Play'
                    className='hide-if-ios'
                />
            </a>
        </div>
    );
}
